import { useContext, useState,useEffect } from "react";
import { useNavigate } from "react-router";
import MyContext from "../../context/Context";
import toast from "react-hot-toast";
import { fireDB } from "../../firebase/FirebaseConfig";
import { getAuth } from "firebase/auth";
import Loader from "../../components/Loader/Loader";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";




const AddResort = () => {
  const context = useContext(MyContext);
  const { loading, setLoading } = context;
  const navigate = useNavigate();

  const auth = getAuth();
  const user = auth.currentUser;
  const users = JSON.parse(localStorage.getItem("users"));

const [resort, setResort] = useState({
  name: "",
  location: "",
  guests: "",
  nights: "",
  price: "",
  description: "",
  facilities: "",
  menu: "",
  roomRates: "",
  inclusions: "",
  weddingBudget: "",
  image: "",
  gallery: [],
  packages: [{ title: "", description: "", price: "" }],
  time: Timestamp.now(),
});



const handlePackageChange = (index, field, value) => {
  const updatedPackages = [...resort.packages];
  updatedPackages[index][field] = value;

  setResort({
    ...resort,
    packages: updatedPackages,
  });
};

const addPackageField = () => {
  setResort({
    ...resort,
    packages: [...resort.packages, { title: "", description: "", price: "" }],
  });
};

const removePackageField = (index) => {
  const updatedPackages = resort.packages.filter((_, i) => i !== index);

  setResort({
    ...resort,
    packages: updatedPackages,
  });
};

  

  const [imageFiles, setImageFiles] = useState([null]);

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    const newFiles = [...imageFiles];
    newFiles[index] = file;
    setImageFiles(newFiles);
  };

  const removeImageField = (index) => {
    const newFiles = imageFiles.filter((_, i) => i !== index);
    setImageFiles(newFiles);
  };

const uploadImagesAndGetUrls = async () => {
  const storage = getStorage();
  const urls = [];

  for (const file of imageFiles) {
    if (file) {
      const storageRef = ref(
        storage,
        `resortImages/${Date.now()}-${file.name}`
      );
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      urls.push(downloadURL);
    }
  }

  return urls;
};

const addResortFunction = async () => {
  if (
    !resort.name ||
    !resort.location ||
    !resort.price ||
    imageFiles.length === 0
  ) {
    return toast.error("All required fields are missing");
  }

  if (!user) {
    return toast.error("User not authenticated");
  }

  setLoading(true);

  try {
    const imageUrls = await uploadImagesAndGetUrls();

    const resortRef = collection(fireDB, "resorts");

    await addDoc(resortRef, {
      ...resort,
      image: imageUrls[0], // main image
      gallery: imageUrls, // full gallery
      guests: Number(resort.guests),
      nights: Number(resort.nights),
      facilities: resort.facilities
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
      menu: resort.menu
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
      roomRates: resort.roomRates
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
      inclusions: resort.inclusions
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
      // ✅ IMPORTANT
      packages: resort.packages.filter(
        (pkg) => pkg.title && pkg.description && pkg.price
      ),
      userId: user.uid,
      createdAt: Timestamp.now(),
    });

    toast.success("Resort added successfully!");
    navigate("/adminDashboard");
  } catch (error) {
    console.error(error);
    toast.error("Failed to add resort");
  } finally {
    setLoading(false);
  }
};



return (
  <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 p-6">
    {loading && (
      <div className="fixed inset-0 bg-white/70 backdrop-blur-sm z-50 flex items-center justify-center">
        <Loader />
      </div>
    )}

    <div className="w-full max-w-2xl bg-white shadow-2xl rounded-2xl p-8 border border-gray-200">
      <h2 className="text-center text-3xl font-bold text-gray-800 mb-8">
        Add Resorts
      </h2>

      {/* Common Input Style */}
      {/** Use this class everywhere */}
      {/** w-full px-4 py-3 mb-4 border border-gray-300 rounded-xl bg-white 
           focus:outline-none focus:ring-2 focus:ring-blue-500 
           focus:border-blue-500 transition shadow-sm */}

      <input
        type="text"
        placeholder="Resort Name"
        value={resort.name}
        onChange={(e) => setResort({ ...resort, name: e.target.value })}
        className="w-full px-4 py-3 mb-4 border border-gray-300 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition shadow-sm"
      />

      <input
        type="text"
        placeholder="Location"
        value={resort.location}
        onChange={(e) => setResort({ ...resort, location: e.target.value })}
        className="w-full px-4 py-3 mb-4 border border-gray-300 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition shadow-sm"
      />

      <div className="grid grid-cols-2 gap-4">
        <input
          type="number"
          placeholder="Guests"
          value={resort.guests}
          onChange={(e) => setResort({ ...resort, guests: e.target.value })}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition shadow-sm"
        />

        <input
          type="number"
          placeholder="Nights"
          value={resort.nights}
          onChange={(e) => setResort({ ...resort, nights: e.target.value })}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition shadow-sm"
        />
      </div>

      <input
        type="text"
        placeholder="Price"
        value={resort.price}
        onChange={(e) => setResort({ ...resort, price: e.target.value })}
        className="w-full px-4 py-3 mt-4 mb-4 border border-gray-300 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition shadow-sm"
      />

      {/* Image Upload */}
      <div className="mb-4">
        {imageFiles.map((file, index) => (
          <div key={index} className="flex items-center gap-3 mb-3">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, index)}
              className="w-full text-sm text-gray-600
              file:mr-4 file:py-2 file:px-4
              file:rounded-lg file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
            />
            {imageFiles.length > 1 && (
              <button
                type="button"
                onClick={() => removeImageField(index)}
                className="text-red-500 text-sm hover:underline"
              >
                Remove
              </button>
            )}
          </div>
        ))}

        {imageFiles.length < 5 && (
          <button
            type="button"
            onClick={() => setImageFiles([...imageFiles, null])}
            className="text-blue-600 text-sm hover:underline"
          >
            + Add Image
          </button>
        )}
      </div>

      <input
        type="text"
        placeholder="Wedding Budget"
        value={resort.weddingBudget}
        onChange={(e) =>
          setResort({ ...resort, weddingBudget: e.target.value })
        }
        className="w-full px-4 py-3 mb-4 border border-gray-300 rounded-xl bg-white focus:ring-2 focus:ring-blue-500 transition shadow-sm"
      />

      <textarea
        placeholder="Resort Description"
        value={resort.description}
        onChange={(e) => setResort({ ...resort, description: e.target.value })}
        rows="4"
        className="w-full px-4 py-3 mb-4 border border-gray-300 rounded-xl bg-white focus:ring-2 focus:ring-blue-500 transition shadow-sm resize-none"
      />

      {/* Packages Section */}
      <h3 className="text-lg font-semibold mt-6 mb-3 text-gray-700">
        Wedding Packages
      </h3>

      {resort.packages.map((pkg, index) => (
        <div key={index} className="bg-gray-50 p-4 rounded-xl mb-4 border">
          <input
            type="text"
            placeholder="Package Title"
            value={pkg.title}
            onChange={(e) =>
              handlePackageChange(index, "title", e.target.value)
            }
            className="w-full px-4 py-2 mb-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />

          <textarea
            placeholder="Package Description"
            value={pkg.description}
            onChange={(e) =>
              handlePackageChange(index, "description", e.target.value)
            }
            className="w-full px-4 py-2 mb-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />

          <input
            type="text"
            placeholder="Package Price"
            value={pkg.price}
            onChange={(e) =>
              handlePackageChange(index, "price", e.target.value)
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />

          {resort.packages.length > 1 && (
            <button
              type="button"
              onClick={() => removePackageField(index)}
              className="text-red-500 text-sm mt-2 hover:underline"
            >
              Remove Package
            </button>
          )}
        </div>
      ))}

      <button
        type="button"
        onClick={addPackageField}
        className="text-blue-600 text-sm hover:underline mb-6"
      >
        + Add Another Package
      </button>

      <button
        onClick={addResortFunction}
        type="button"
        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 rounded-xl font-semibold shadow-lg transition duration-300"
      >
        Add Resort
      </button>
    </div>
  </div>
);

};

export default AddResort;
